export const MAX_FIRST_PARAGRAPH_LENGTH = 400;
export const MAX_EXPANDED_HEIGHT = '9999px';
export const FILTERED_COMPONENTS = ['SMBWhyTrustNerdWallet'] as const;
